import request from '../../library/request';
import setGlobalState from '../setGlobalState';

export const getETicket = async (token: string) => {
    const res = await request('eTicket.getETicket', 'get', `/api/eTicket/${token}`);
    setGlobalState('eTicket', {oid: res?.order?.oid ?? null, data: res, error: null});
    return res;
};
